import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children, roles, allowWhenMustChangePassword = false }) {
    const { user } = useAuth();
    const loc = useLocation();
    if (user === null)
        return (
            <div className="min-h-screen flex items-center justify-center text-stone-500 text-sm">
                Loading…
            </div>
        );
    if (user === false) return <Navigate to="/login" replace />;
    // Forced password change — hard-redirect everywhere except the change screen itself
    if (user?.must_change_password && !allowWhenMustChangePassword && loc.pathname !== "/change-password") {
        return <Navigate to="/change-password?forced=1" replace />;
    }
    if (roles && roles.length && !roles.includes(user.role))
        return (
            <div className="p-10 text-stone-600 text-sm">
                <div className="font-display text-3xl text-stone-900 mb-2">
                    Access restricted
                </div>
                Your role ({user.role}) does not have permission to view this page.
            </div>
        );
    return children;
}
